import type { TrainingLessonSpecific } from './trainingLessonUi';

export const core2PlanOfSalvationEs: TrainingLessonSpecific = {
  intro:
    'El Plan de Salvación explica nuestro origen, propósito en la tierra y destino eterno. En esta lección explorarás sus fundamentos y cómo te guía cada día.',
  objectives: [
    'Comprender los tres reinos de gloria y el propósito de la vida terrenal',
    'Identificar el papel del Salvador en el Plan de Salvación',
    'Reconocer la importancia del albedrío y las consecuencias de nuestras decisiones',
    'Reflexionar sobre cómo el Plan te da propósito y esperanza',
    'Aplicar principios del Plan en decisiones diarias',
  ],
  briefHeading: 'El Plan en breve',
  briefBody:
    'Vivimos con nuestro Padre Celestial antes de nacer. Venimos a la tierra para recibir un cuerpo, ser probados y progresar. Gracias al Salvador, podemos arrepentirnos, ser perdonados y regresar a la presencia de Dios. Nuestro albedrío nos permite elegir el camino que seguiremos.',
  scriptures: [
    {
      ref: '2 Nefi 2:25',
      text: 'Adán cayó para que los hombres existiesen; y los hombres existen para que tengan gozo.',
    },
    {
      ref: 'Alma 34:32',
      text: 'Porque he aquí, esta vida es cuando el hombre debe prepararse para comparecer ante Dios; sí, el día de esta vida es el día en que el hombre debe realizar su obra.',
    },
    {
      ref: 'Moisés 1:39',
      text: 'Porque he aquí, esta es mi obra y mi gloria: Llevar a cabo la inmortalidad y la vida eterna del hombre.',
    },
    {
      ref: '2 Nefi 2:27',
      text: 'Los hombres son libres según la carne... para escoger la libertad y la vida eterna... o la cautividad y la muerte.',
    },
    {
      ref: 'Doctrina y Convenios 76:22',
      text: 'Y ahora, después de los muchos testimonios que se han dado de él, este es el testimonio... que vive.',
    },
  ],
  didYouKnow: [
    'La expresión "Plan de Salvación" aparece en el Libro de Mormón (Alma 42:5) y en Doctrina y Convenios, revelando que es un concepto central en la Restauración.',
    'Los tres reinos de gloria (celestial, terrestre, telestial) fueron revelados a José Smith en 1832 (DyC 76), mostrando la misericordia de Dios hacia todos Sus hijos.',
  ],
  practiceItems: [
    'Leer 2 Nefi 2',
    'Meditar en Alma 34:32 y qué significa "prepararse" para ti',
    'Identificar una decisión reciente donde usaste tu albedrío',
    'Escribir una oración de gratitud por el Plan de Salvación',
    'Compartir con alguien qué te da esperanza del Plan',
  ],
  reflectionQuestions: [
    '¿Cómo te ayuda el Plan de Salvación a dar sentido a las pruebas que enfrentas?',
    '¿De qué manera el albedrío te ha permitido acercarte al Salvador?',
    '¿Qué aspecto del Plan (premortal, mortal, postmortal) te resulta más significativo ahora?',
  ],
  actionText:
    'En una oración, agradece al Padre Celestial por el Plan de Salvación y pide guía para una decisión que estés enfrentando.',
};
